import React from 'react'
import './BodyScanHeader.scss';

const BodyScanHeader = ({onCancel, onRestart}) => (
  <header className="body-scan-header--container">
    <label role="button" onClick={onCancel}>Cancel</label>
    <h2>Body Scan</h2>
    <label role="button" onClick={onRestart}>Restart</label>
  </header>
)

export default BodyScanHeader